<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2024-10-07 19:24 -->
<!-- Description:  -->
<template>
  <div>
    <h4>Control Mensual</h4>
    <div class="row">
      <div class="col-lg-6 mb-3">
        <SelectDateRange ref="elSelectDateRange"></SelectDateRange>
      </div>
    </div>
    <div class="mb-3">
      <button type="button" class="btn btn-primary" @click="reload()">
        Generar
      </button>
    </div>
    <div class="row">
      <div class="col-lg-8 col-md-6">
        <ControlTableResumeByEmployee ref="elControlTableResumeByEmployee">
        </ControlTableResumeByEmployee>
      </div>
      <div class="col-lg-4">
        <h4>VENTAS POR M. PAGO</h4>
        <TableResumePayMethod ref="elTableResumePayMethod"></TableResumePayMethod>
        <!-- <TableResumePayMethod ref="elTableResumeOutput"></TableResumePayMethod> -->
        <h4>HISTORICO</h4>
        <LineChart ref="elResumeLineChart"></LineChart>
      </div>
    </div>
    <TableControlView :list="list"></TableControlView>
  </div>
</template>
<script>
import {myMoment} from "../../utils/myMoment";
import {DentalClinicService} from "../service";
import SelectDateRange from "./SelectDateRange.vue";
import TableControlView from "./TableControlView.vue";
// import _ from "lodash";
import LineChart from "./LineChart.vue";
import ControlTableResumeByEmployee from "./ControlTableResumeByEmployee.vue";
import TableResumePayMethod from "./TableResumePayMethod.vue";

// script content
export default {
  name: "ControlByMonth",
  components: {
    SelectDateRange,
    TableControlView,
    LineChart,
    ControlTableResumeByEmployee,
    TableResumePayMethod,
  },

  // directives

  props: {
    //
  },

  data: () => ({
    date_ini: null,
    date_end: null,
    list: [],
    group_doctor: [],
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    this.reload()
  },

  methods: {
    async reload() {
      [this.date_ini, this.date_end] = this.$refs.elSelectDateRange.getRange();
      this.$refs.elControlTableResumeByEmployee.reset();
      this.$refs.elTableResumePayMethod.reset();
      let res = await DentalClinicService.getControlRange({
        date_ini: this.date_ini,
        date_end: this.date_end,
      });
      this.list = res;
      // let groupDoctor = _.groupBy(res, "employee_id");
      // let groupDoctorResults = [];
      // for (let keyIt in groupDoctor) {
      //   let registers = groupDoctor[keyIt];
      //   let amountPaid = registers.reduce(function(p, c) {
      //     return p + parseFloat(c.amount_paid);
      //   }, 0);
      //   groupDoctorResults.push({
      //     name: keyIt > 0 ? registers[0].doctor : "Otros",
      //     employee_id: registers[0].employee_id,
      //     amount_paid: amountPaid,
      //   });
      // }
      // this.group_doctor = groupDoctorResults;
      let lastDate = myMoment(this.date_end);
      let resume = await DentalClinicService.getResumeMonthly({
        year: lastDate.year(),
        month: lastDate.month() + 1,
        months: 6,
      });
      this.generateResumeLineChart(resume);
      this.$refs.elControlTableResumeByEmployee.generate(res);
      this.$refs.elTableResumePayMethod.generate(res);
      // this.$refs.elTableResumeOutput.generate();
    },
    generateResumeLineChart(resume) {
      let sales = resume.sales.reverse();
      let outs = resume.outs.reverse();
      this.$refs.elResumeLineChart.generate({
        labels: sales.map((x) => `${x.year}-${x.month}`),
        datasets: [
          {
            label: "Ventas",
            data: sales.map((x) => x.amount),
            borderColor: "blue",
          },
          {
            label: "Gastos",
            data: outs.map((x) => x.amount),
            borderColor: "red",
          }
        ],
      });
    },
    //
    //
  },
};
</script>
<style scoped>
</style>
